const $ = require('jquery');
import { tns } from 'tiny-slider/src/tiny-slider';
import { initAuthAction } from "../../../new_design/common/auth";

$(function () {
  document.addEventListener('client_is_checked', initAuthAction);

  initHotelsSlider();
});

function initHotelsSlider() {
  const $sliderContainer = $('.main-page-section .slider-tns');
  const $sliderControls = $('.main-page-section .slider-tns__arrows');

  const sliderTns = tns({
    container: $sliderContainer[0],
    mode: 'carousel',
    items: 3,
    controls: true,
    controlsContainer: $sliderControls[0],
    nav: false,
    axis: 'horizontal',
    startIndex: 0,
    slideBy: 'page',
    mouseDrag: false,
    lazyload: true,
    loop: false,
  });

  if (!sliderTns) return;

  sliderTns.events.on('indexChanged', ({ index }) => {
    $sliderControls.find('.slider-tns__thumb-arrow-left').toggle(index !== 0);
    $sliderControls.find('.slider-tns__thumb-arrow-right').toggle(index !== 3);
  });
}
